import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME, toggleLogoutPopup } from '../../../sidebar/reducer';
import { ConfirmPopup } from '../../../../common/popup';
import { I18n } from 'react-redux-i18n';

class PopupConfirmLogout extends React.Component {
  render() {
    const { isShowPopupLogout, toggleLogoutPopup } = this.props;
    return (
      <ConfirmPopup
        title={I18n.t(`layout.logout.title`)}
        messages={[I18n.t('layout.logout.message')]}
        isShow={isShowPopupLogout}
        enabledCancel={true}
        enabledApply={true}
        confirm={toggleLogoutPopup}
        iconName={'icon-help'}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    isShowPopupLogout: state[REDUCER_NAME].userInfo.isShowPopupLogout,
  };
};

const mapDispatchToProps = {
  toggleLogoutPopup,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PopupConfirmLogout);
